import { Feature } from '@/enums/feature';
import { FeatureRole, OrganizationRole, type Role } from '@/enums/roles';
import type { OrganizationEmployee } from '@/types/employee';
import { useI18n } from 'vue-i18n';

export const roleFeatureMap: Partial<Record<FeatureRole, Feature>> = {
    [FeatureRole.ActionCoordinator]: Feature.ActionCoordinatorRole
};

export function getRoleFromFeatures(features?: Feature[]) {
    if (!features) return [];
    return features
        .map((f) => {
            const featureKey = Object.keys(Feature).find((key) => Feature[key as keyof typeof Feature] === f);
            if (!featureKey) return;

            const roleKey = featureKey.replace(/Role$/, '');
            return FeatureRole[roleKey as keyof typeof FeatureRole];
        })
        .filter((r) => !!r);
}

export function getEnumNameFromRole(role: Role) {
    return Object.values(OrganizationRole).includes(role as OrganizationRole) ? 'OrganizationRole' : 'FeatureRole';
}

export function getTranslatedRoles(employee: OrganizationEmployee) {
    if (employee.roles?.length === 0) return '-';
    return employee.roles.map((role) => getTranslatedRole(employee, role)).join(', ');
}

function getTranslatedRole(employee: OrganizationEmployee, role: Role) {
    const { t: translate } = useI18n();

    const featureRole = getRoleFromFeatures(employee.features)?.[0];
    if (featureRole) role = featureRole;

    const enumName = getEnumNameFromRole(role);
    const shouldAppendReadOnly = employee.isReadOnly && !employee.features?.includes(Feature.ActionCoordinatorRole);

    return `${translate(`enums.${enumName}.${role}`)}${shouldAppendReadOnly ? ' (alleen lezen)' : ''}`;
}
